import React from "react";
import { BrookshireBrotherLogoWithTagline } from "../../../assets";
import { NEXCALIBER_SUPPORT_MEMBERS } from "../../../constants/companyDetails.constants";

import "./footer.scss";

const Footer: React.FC = (): JSX.Element => {
	const handleScrollToTop = () => {
		window.scrollTo({
			top: 0,
			behavior: "smooth"
		});
	};
	return (
		<>
			<footer>
				<div className="footer">
					<div className="row">
						<img src={BrookshireBrotherLogoWithTagline} alt="" />
					</div>

					<div className="row">
						<div className="contact-group-container">
							{/* <div className="contact-container">
								<div className="designation">
									{NEXCALIBER_SUPPORT_MEMBERS.beezly_limited_indemnity.designation}
								</div>
								<div className="provider-name">
									{NEXCALIBER_SUPPORT_MEMBERS.beezly_limited_indemnity.name}
								</div>
								<div className="provider-contacts">
									{NEXCALIBER_SUPPORT_MEMBERS.beezly_limited_indemnity.contact}
								</div>
							</div> */}
							<div className="contact-container">
								<div className="designation">{NEXCALIBER_SUPPORT_MEMBERS.beca_boland.designation}</div>
								<div className="provider-name">{NEXCALIBER_SUPPORT_MEMBERS.beca_boland.name}</div>
								<div className="provider-contacts">
									{NEXCALIBER_SUPPORT_MEMBERS.beca_boland.contact}
								</div>
							</div>
							<div className="contact-container">
								<div className="designation">
									{NEXCALIBER_SUPPORT_MEMBERS.jenifer_robertson.designation}
								</div>
								<div className="provider-name">{NEXCALIBER_SUPPORT_MEMBERS.jenifer_robertson.name}</div>
								<div className="provider-contacts">
									{NEXCALIBER_SUPPORT_MEMBERS.jenifer_robertson.contact}
								</div>
							</div>
							{/* <div className="contact-container">
								<div className="designation">{NEXCALIBER_SUPPORT_MEMBERS.medmutual.designation}</div>
								<div className="provider-name">{NEXCALIBER_SUPPORT_MEMBERS.medmutual.name}</div>
								<div className="provider-contacts">{NEXCALIBER_SUPPORT_MEMBERS.medmutual.contact}</div>
							</div> */}
							<div className="contact-container">
								<div className="designation">{NEXCALIBER_SUPPORT_MEMBERS.nexcaliber.designation}</div>
								<div className="provider-name">Nexcaliber</div>
								<div className="provider-contacts">{NEXCALIBER_SUPPORT_MEMBERS.nexcaliber.contact}</div>
							</div>
							<div className="contact-container">
								<div className="designation">
									{NEXCALIBER_SUPPORT_MEMBERS.benefits_call_center.designation}
								</div>
								<div className="provider-name">
									{NEXCALIBER_SUPPORT_MEMBERS.benefits_call_center.name}
								</div>
								<div className="provider-contacts">
									{NEXCALIBER_SUPPORT_MEMBERS.benefits_call_center.contact}
								</div>
							</div>
						</div>
					</div>
					<div className="scroll scroll--active">
						<button onClick={handleScrollToTop} className="top-btn" type="button">
							<span className="sr-only">Scroll to Top</span>
						</button>
					</div>

					<div className="row-copyright">
						<span>Nexcaliber</span>
						<span>&copy;</span>
						<small>{new Date().getFullYear()} All Rights Reserved.</small>
					</div>
				</div>
			</footer>
		</>
	);
};

export default Footer;
